import { App as AntdApp, ConfigProvider } from "antd";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <AntdApp>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <RecoilRoot>
        <ConfigProvider
          theme={{
            token: { colorPrimary: "#374b91" },
            components: {
              Table: {
                headerBg: "#fff",
              },
            },
          }}
        >
          <App />
        </ConfigProvider>
      </RecoilRoot>
    </BrowserRouter>
  </AntdApp>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
